import { isTab } from "./keyHelper";
const focusableElements =
  'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="file"]:not([disabled]), label[tabIndex]:not([disabled]), select:not([disabled])';

/**
 * Function for trapping focus within an element
 * Lets a user tab between the first and last element in a circular fashion
 * @param {HTMLElement} element the element to trap focus in
 */
export function trapFocus(element) {
  // get all focusable elements in the provided element
  const focusableEls = element.querySelectorAll(focusableElements);
  const firstEl = focusableEls[0];
  const lastEl = focusableEls[focusableEls.length - 1];

  // listen for key presses
  element.addEventListener("keydown", (e) => {
    // if the tab key is pressed
    if (isTab(e)) {
      // if going back up the dom, check if we're already on the first element
      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          lastEl.focus();
          e.preventDefault();
        }
        //if going forwards through the dom, check we're not on the last element
      } else {
        if (document.activeElement === lastEl) {
          firstEl.focus();
          e.preventDefault();
        }
      }
    }
  });
}

/**
 * Function for assigning focus to the first focusable element in an element
 * @param {HTMLElement} element the element to search for focusable elements in
 */
export function focusFirstElement(element) {
  const focusableEl = element.querySelector(focusableElements);
  focusableEl.focus();
}
